
<div *ngIf="!isConnected" [ngClass]="{'toast-danger': status != 'ONLINE','toast-success': status == 'ONLINE'}" class="ak-alert toast botton-left    {{!isConnected?'animate__animated animate__fadeIn animate__faster ':'' }}">

    <div class="toast-body">
        <span *ngIf="status == 'ONLINE'">
            Conexión restablecida
        </span>
        <span *ngIf="status == 'OFFLINE'">
            Se está intentando establecer la conexión...<br> Revise su conexión a la red
        </span>
    </div>
</div>


<div class="pb-5 mb-3" *ngIf="env?.inactive" >
    <div class="col-12 col-md-4 offset-md-4 pb-4">

        <img width="98%" id="appear" class="" [src]="sanitize('../assets/inactive.png')" alt="IconoWhatsApp" />
        </div>
</div>

<!-- Biometría Component -->
<app-biometria *ngIf="biometria && !env?.inactive">
</app-biometria>

<!-- Main Application Layout -->
<div *ngIf="!biometria && !env?.inactive">
    <!-- New Sidebar Layout -->
    <div *ngIf="showNav && isAuth">
        <app-side-bar>
            <router-outlet></router-outlet>
        </app-side-bar>
    </div>

    <!-- Login/Public Layout (without sidebar) -->
    <div *ngIf="!showNav || !isAuth" class="min-h-screen bg-gray-50">
    <router-outlet></router-outlet>
    </div>
</div>

<!-- Mobile Menu (Mobiscroll) - Keep for mobile compatibility -->
<div *ngIf="isAuth && activeMenu && !biometria && !env?.inactive && !isWidgetRoute" class="d-block d-md-none fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 lg:hidden">
    <div class="md-pic-edit">
        <mbsc-optionlist [options]="settings">
            <mbsc-option-item data-text="Activos">
                <div (click)="setOptionMenu(1);closeOffcanvas()" [routerLink]="['/console/create-constacts']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 1}">
                        <i class="fas fa-users"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Contactos
                        </div>
                    </div>
                </div>
            </mbsc-option-item>

            <mbsc-option-item data-text="Ventas">
                <div (click)="setOptionMenu(2);closeOffcanvas()" [routerLink]="['/console/ventas']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 2}">
                        <i class="fas fa-shopping-bag"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Ventas
                        </div>
                    </div>
                </div>
            </mbsc-option-item>

            <mbsc-option-item data-text="Finanzas">
                <div (click)="setOptionMenu(4);closeOffcanvas()" [routerLink]="['/console/finanzas2']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 4}">
                        <i class="fas fa-chart-line"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Finanzas
                        </div>
                    </div>
                </div>
            </mbsc-option-item>

            <mbsc-option-item data-text="Cobranza">
                <div (click)="setOptionMenu(6);closeOffcanvas()" [routerLink]="['/console/cobranza']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 6}">
                        <i class="fas fa-hand-holding-usd"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Cobranza
                        </div>
                    </div>
                </div>
            </mbsc-option-item>

            <mbsc-option-item data-text="Crédito">
                <div (click)="setOptionMenu(7);closeOffcanvas()" [routerLink]="['/console/credito']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 7}">
                        <i class="fas fa-credit-card"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Crédito
                        </div>
                    </div>
                </div>
            </mbsc-option-item>

            <mbsc-option-item data-text="Parámetros">
                <div (click)="setOptionMenu(8);closeOffcanvas()" [routerLink]="['/console/parametros-sistema']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 8}">
                        <i class="fas fa-cogs"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Parámetros
                        </div>
                    </div>
                </div>
            </mbsc-option-item>

            <mbsc-option-item data-text="Finanzas" *ngIf="_auth.hasAccessOrProfile('finanzas', ['OWNER','ANALIST','FINANCIAL'])">
                <div (click)="setOptionMenu(3);closeOffcanvas()" [routerLink]="['/console/finacial-dashboard']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 3}">
                        <i class="fas fa-piggy-bank"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Finanzas
                        </div>
                    </div>
                </div>
            </mbsc-option-item>

            <mbsc-option-item data-text="Estadísticas" *ngIf="_auth.hasAccessOrProfile('reportes', ['OWNER','ANALIST'])">
                <div (click)="setOptionMenu(2);closeOffcanvas()" [routerLink]="['/console/estadisticas']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 2}">
                        <i class="fas fa-tablet-alt"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Estadísticas
                        </div>
                    </div>
                </div>
            </mbsc-option-item>

            <mbsc-option-item data-text="Consola" *ngIf="_auth.hasAccessOrProfile('credito', ['OWNER','ANALIST'])">
                <div (click)="setOptionMenu(5);closeOffcanvas()" [routerLink]="['/console/credit-option']">
                    <div class="icon-menu-mbs" [ngClass]="{'active': menuOption == 5}">
                        <i class="fas fa-terminal"></i>
                    </div>
                    <div class="text-center active-cursor">
                        <div class="active-cursor text-center text-secondary fz-12">
                            Consola
                        </div>
                    </div>
                </div>
            </mbsc-option-item>
        </mbsc-optionlist>
    </div>
</div>

<!-- Descargas en curso: una sola vez, cubre todas las pantallas -->
<app-descargas-en-curso></app-descargas-en-curso>
